import { Component, computed, effect, inject, input } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ConfirmationService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { Tooltip } from 'primeng/tooltip';
import { QuizQuestionFacade } from '@app/store/quiz-question';
import { AssignmentsFacade } from '@app/store/assignments';

@Component({
    selector: 'app-delete-button',
    templateUrl: './delete-button.component.html',
    styleUrls: ['./delete-button.component.css'],
    imports: [TranslateModule, ButtonModule, Tooltip],
})
export class DeleteButtonComponent {
    private readonly quizQuestionFacade = inject(QuizQuestionFacade);
    private readonly assignmentsFacade = inject(AssignmentsFacade);
    private readonly confirmationService = inject(ConfirmationService);
    private readonly translateService = inject(TranslateService);

    readonly quizQuestionId = input.required<string>();
    readonly saving = input<boolean>(false);
    readonly testId = input.required<string>();

    readonly hasAssignments = computed(() => this.assignmentsFacade.assignments(this.quizQuestionId(), 'quiz-question')().length > 0);

    constructor() {
        effect(() => {
            this.assignmentsFacade.getAssignments(this.quizQuestionId(), 'quiz-question');
        });
    }

    onDelete(): void {
        this.confirmationService.confirm({
            header: this.translateService.instant('quiz-questions.delete.header'),
            message: this.translateService.instant('quiz-questions.delete.message'),
            icon: 'pi pi-exclamation-triangle',
            rejectButtonProps: {
                label: this.translateService.instant('quiz-questions.delete.reject'),
                severity: 'secondary',
                outlined: true,
            },
            acceptButtonProps: {
                label: this.translateService.instant('quiz-questions.delete.accept'),
                severity: 'danger',
            },
            accept: () => {
                this.quizQuestionFacade.deleteQuizQuestion(this.quizQuestionId());
            },
        });
    }
}
